import api from './api';

export const attachmentService = {
  list: (ticketId) => api.get(`/tickets/${ticketId}/attachments`),
  upload: (ticketId, file, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/tickets/${ticketId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    });
  },
  download: (ticketId, attachmentId) =>
    api.get(`/tickets/${ticketId}/attachments/${attachmentId}/download`, {
      responseType: 'blob',
    }),
  delete: (ticketId, attachmentId) =>
    api.delete(`/tickets/${ticketId}/attachments/${attachmentId}`),
};
